if (!customElements.get('projects-header')) {
  /* Mobil kırılım: bu genişliğin altında seçenekler alttan açılan panelde gösterilir. */
  const PH_MOBILE_QUERY = '(max-width: 767px)';
  /* Bu sayıdan fazla seçenekte listeye arama kutusu eklenir. */
  const PH_SEARCH_THRESHOLD = 7;
  /* Mobilde proje seçimi de alt panelde; panel bu sahte parametreyle doldurulur. */
  const PH_PROJECT_PARAM = '__project';
  /* İletişim bilgisi bir sonraki teklifte hazır gelsin (yalnız bu tarayıcıda). */
  const PH_CONTACT_STORAGE_KEY = 'ph-appraisal-contact';

  class ProjectsHeader extends HTMLElement {
    constructor() {
      super();
      this.apiBase = (this.dataset.apiBase || 'https://backoffice.rendrea.com').replace(/\/+$/, '');

      this.panel = this.querySelector('[data-panel]');
      this.combo = this.querySelector('[data-combo]');
      this.comboValue = this.querySelector('[data-combo-value]');
      this.popoverEl = this.querySelector('[data-combo-popover]');
      this.searchInput = this.querySelector('[data-combo-search]');
      this.listEl = this.querySelector('[data-combo-list]');
      this.quickpicks = this.querySelector('[data-quickpicks]');
      this.teklifButton = this.querySelector('[data-teklif-button]');
      this.messageEl = this.querySelector('[data-message]');
      this.progressEl = this.querySelector('[data-progress]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.progressText = this.querySelector('[data-progress-text]');

      this.sheet = this.querySelector('[data-sheet]');
      this.sheetTitle = this.querySelector('[data-sheet-title]');
      this.sheetSubtitle = this.querySelector('[data-sheet-subtitle]');
      this.sheetSearchWrap = this.querySelector('[data-sheet-search-wrap]');
      this.sheetSearch = this.querySelector('[data-sheet-search]');
      this.sheetList = this.querySelector('[data-sheet-list]');
      this.projectCountEl = this.querySelector('[data-project-count]');
      this.sheetParam = null;

      this.contact = this.querySelector('[data-contact]');
      this.contactForm = this.querySelector('[data-contact-form]');
      this.contactSubtitle = this.querySelector('[data-contact-subtitle]');
      this.contactName = this.querySelector('[data-contact-name]');
      this.contactPhone = this.querySelector('[data-contact-phone]');
      this.contactError = this.querySelector('[data-contact-error]');
      this.contactSubmit = this.querySelector('[data-contact-submit]');
      this.pendingSelections = null;

      this.projects = [];
      this.filtered = [];
      this.activeIndex = -1;
      this.projectCode = '';
      this.projectName = '';
      this.params = [];
      this.selections = {};
      this.openField = null;
      this.hasParams = false;
      this.loading = false;
      this.mobileQuery = window.matchMedia(PH_MOBILE_QUERY);
    }

    connectedCallback() {
      this.bindOutsideClick();
      if (this.panel) this.panel.addEventListener('submit', (e) => this.onTeklifClick(e));
      if (this.teklifButton) this.setButtonEnabled(false);
      this.wireCombo();
      this.wireSheet();
      this.wireContact();
      this.loadProjectList();
    }

    disconnectedCallback() {
      if (this.contact && this.contact.parentNode === document.body) this.contact.remove();
    }

    /* ================= Proje listesi (combobox + çipler) ================= */
    async loadProjectList() {
      try {
        const res = await fetch(`${this.apiBase}/v1/shopify/appraisal/projects`, {
          headers: { Accept: 'application/json' },
        });
        const data = await res.json();
        if (!res.ok || !data || data.success !== true || !Array.isArray(data.projects)) {
          throw new Error((data && data.message) || 'Projeler yüklenemedi.');
        }
        if (data.projects.length === 0) {
          this.setComboPlaceholder('Şu anda proje bulunmuyor');
          return;
        }
        this.projects = data.projects.filter((p) => p && p.code);
        this.renderComboList(this.projects);
        /* Mobilde tümü yatay kayar; masaüstünde CSS ilk 4'ü gösterir. */
        this.renderChips(this.projects);
        if (this.projectCountEl) this.projectCountEl.textContent = `${this.projects.length} proje`;
      } catch (err) {
        this.showMessage('Projeler yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin.');
      }
    }

    wireCombo() {
      if (!this.combo) return;
      this.combo.addEventListener('click', (e) => {
        if (this.popoverEl && this.popoverEl.contains(e.target)) return;
        this.toggleCombo();
      });
      this.combo.addEventListener('keydown', (e) => {
        if (e.target !== this.combo) return;
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.openCombo();
        } else if (e.key === 'Escape') {
          this.closeCombo();
        }
      });
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => this.filterCombo(this.searchInput.value));
        this.searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') { e.preventDefault(); this.moveActive(1); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); this.moveActive(-1); }
          else if (e.key === 'Enter') { e.preventDefault(); this.selectActive(); }
          else if (e.key === 'Escape') { e.preventDefault(); this.closeCombo(); this.combo.focus(); }
        });
      }
    }

    toggleCombo() {
      if (this.combo.classList.contains('is-open')) this.closeCombo();
      else this.openCombo();
    }

    openCombo() {
      if (!this.popoverEl || !this.projects.length) return;
      if (this.mobileQuery.matches) {
        this.openProjectSheet();
        return;
      }
      this.closeFieldPopover();
      this.combo.classList.add('is-open');
      this.combo.setAttribute('aria-expanded', 'true');
      this.popoverEl.hidden = false;
      if (this.searchInput) {
        this.searchInput.value = '';
        this.filterCombo('');
        setTimeout(() => this.searchInput.focus(), 0);
      }
    }

    closeCombo() {
      if (!this.popoverEl) return;
      this.combo.classList.remove('is-open');
      this.combo.setAttribute('aria-expanded', 'false');
      this.popoverEl.hidden = true;
      this.activeIndex = -1;
    }

    filterCombo(query) {
      const q = (query || '').toLocaleLowerCase('tr').trim();
      this.filtered = q
        ? this.projects.filter((p) => (p.name || p.code).toLocaleLowerCase('tr').indexOf(q) !== -1)
        : this.projects;
      this.renderComboList(this.filtered);
    }

    renderComboList(projects) {
      this.activeIndex = -1;
      if (!this.listEl) return;
      if (!projects.length) {
        this.listEl.innerHTML = '<li class="ph-combo__empty">Sonuç bulunamadı</li>';
        return;
      }
      this.listEl.innerHTML = projects
        .map(
          (p) =>
            `<li class="ph-combo__option" role="option" data-code="${this.esc(p.code)}" aria-selected="${
              p.code === this.projectCode
            }">${this.esc(p.name || p.code)}</li>`
        )
        .join('');
      this.listEl.querySelectorAll('.ph-combo__option').forEach((li) => {
        li.addEventListener('click', () => this.selectOption(li.dataset.code, li.textContent));
      });
    }

    moveActive(dir) {
      const options = this.listEl ? this.listEl.querySelectorAll('.ph-combo__option') : [];
      if (!options.length) return;
      this.activeIndex = (this.activeIndex + dir + options.length) % options.length;
      options.forEach((li, i) => {
        const active = i === this.activeIndex;
        li.classList.toggle('is-active', active);
        if (active) li.scrollIntoView({ block: 'nearest' });
      });
    }

    selectActive() {
      const options = this.listEl ? this.listEl.querySelectorAll('.ph-combo__option') : [];
      const target = this.activeIndex >= 0 ? options[this.activeIndex] : options[0];
      if (target) this.selectOption(target.dataset.code, target.textContent);
    }

    selectOption(code, name) {
      this.closeCombo();
      this.onProjectSelected(code, name);
    }

    renderChips(projects) {
      if (!this.quickpicks || !projects.length) return;
      projects.forEach((p) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'ph-chip';
        chip.textContent = p.name || p.code;
        chip.addEventListener('click', () => this.onProjectSelected(p.code, p.name || p.code));
        this.quickpicks.appendChild(chip);
      });
      this.quickpicks.hidden = false;
    }

    setComboPlaceholder(text) {
      if (this.comboValue) this.comboValue.textContent = text;
    }

    /* ============ Proje seçimi → aynı panele alan kutuları ============ */
    onProjectSelected(code, name) {
      this.projectCode = code;
      this.projectName = name || code;
      if (this.comboValue && name) {
        this.comboValue.textContent = name;
        this.combo.classList.add('is-selected');
      }
      this.hideMessage();
      if (this.quickpicks) this.quickpicks.hidden = true;
      if (this.panel) this.panel.classList.add('is-expanded');

      this.clearParamGroups();
      this.setButtonEnabled(false);
      this.loadParameters(code);
    }

    async loadParameters(code) {
      try {
        const res = await fetch(
          `${this.apiBase}/v1/shopify/appraisal/projects/${encodeURIComponent(code)}`,
          { headers: { Accept: 'application/json' } }
        );
        const data = await res.json();
        if (!res.ok || !data || data.success !== true || !Array.isArray(data.parameters)) {
          throw new Error((data && data.message) || 'Parametreler yüklenemedi.');
        }
        if (code !== this.projectCode) return; // bu arada başka proje seçildi
        this.renderParamGroups(data.parameters);
      } catch (err) {
        this.showMessage('Seçenekler yüklenirken bir hata oluştu.');
      }
    }

    renderParamGroups(parameters) {
      this.params = parameters
        .filter((p) => p && p.code && Array.isArray(p.options) && p.options.length > 0)
        .map((p) => ({
          code: String(p.code),
          name: p.name || p.code,
          options: p.options.map((o) => ({ key: String(o.key), label: String(o.label || o.key) })),
        }));

      if (this.params.length === 0) {
        this.hasParams = false;
        this.showMessage('Bu proje için henüz bilgi girilmemiş.');
        return;
      }

      const markup = this.params.map((p) => this.fieldMarkup(p)).join('');
      if (this.progressEl) this.progressEl.insertAdjacentHTML('beforebegin', markup);
      else this.teklifButton.insertAdjacentHTML('beforebegin', markup);

      this.querySelectorAll('.ph-field').forEach((field) => {
        const trigger = field.querySelector('.ph-field__trigger');
        trigger.addEventListener('click', () => this.toggleField(field));
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closeFieldPopover();
        });
      });

      this.hasParams = true;
      this.updateProgress();
      this.setButtonEnabled(true);
    }

    clearParamGroups() {
      this.closeFieldPopover();
      this.closeSheet();
      this.querySelectorAll('.ph-field').forEach((f) => f.remove());
      this.params = [];
      this.selections = {};
      this.hasParams = false;
      this.updateProgress();
    }

    fieldMarkup(param) {
      const code = this.esc(param.code);
      const name = this.esc(param.name);
      return `
        <div class="ph-field" data-field="${code}">
          <input type="hidden" class="ph-field__input" data-param="${code}" value="">
          <button type="button" class="ph-field__trigger" aria-haspopup="listbox" aria-expanded="false">
            <span class="ph-field__text">
              <span class="ph-field__label">${name}</span>
              <span class="ph-field__value" data-field-value>Seçin</span>
            </span>
            <svg class="ph-field__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
          </button>
        </div>`;
    }

    paramFor(field) {
      return this.params.find((p) => p.code === field.dataset.field) || null;
    }

    toggleField(field) {
      if (this.openField === field) {
        this.closeFieldPopover();
        return;
      }
      const param = this.paramFor(field);
      if (!param) return;
      this.closeCombo();
      if (this.mobileQuery.matches) this.openSheet(field, param);
      else this.openFieldPopover(field, param);
    }

    /* ---- Masaüstü/tablet: alanın altında açılan liste ---- */
    openFieldPopover(field, param) {
      this.closeFieldPopover();
      const withSearch = param.options.length > PH_SEARCH_THRESHOLD;
      const pop = document.createElement('div');
      pop.className = 'ph-field__popover';
      pop.innerHTML = `
        ${withSearch ? `<input type="text" class="ph-field__search" placeholder="Ara…" aria-label="${this.esc(param.name)} ara" autocomplete="off">` : ''}
        <ul class="ph-field__list" role="listbox" aria-label="${this.esc(param.name)}"></ul>`;
      field.appendChild(pop);
      field.classList.add('is-open');
      field.querySelector('.ph-field__trigger').setAttribute('aria-expanded', 'true');
      this.openField = field;

      const list = pop.querySelector('.ph-field__list');
      const render = (q) => this.renderOptionList(list, param, q, 'ph-field__option');
      render('');
      const search = pop.querySelector('.ph-field__search');
      if (search) {
        search.addEventListener('input', () => render(search.value));
        search.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault(); // formu göndermesin; tek sonuç kaldıysa onu seç
            const only = list.querySelectorAll('button[data-key]');
            if (only.length === 1) only[0].click();
          } else if (e.key === 'Escape') {
            this.closeFieldPopover();
            field.querySelector('.ph-field__trigger').focus();
          }
        });
        setTimeout(() => search.focus(), 0);
      }
    }

    closeFieldPopover() {
      if (!this.openField) return;
      const field = this.openField;
      this.openField = null;
      field.classList.remove('is-open');
      const trigger = field.querySelector('.ph-field__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      const pop = field.querySelector('.ph-field__popover');
      if (pop) pop.remove();
    }

    /* ---- Mobil: alttan açılan panel ---- */
    wireSheet() {
      if (!this.sheet) return;
      this.sheet.querySelectorAll('[data-sheet-close]').forEach((el) =>
        el.addEventListener('click', () => this.closeSheet(true))
      );
      this.sheet.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeSheet(true);
      });
      if (this.sheetSearch) {
        this.sheetSearch.addEventListener('input', () => {
          if (this.sheetParam) {
            this.renderOptionList(this.sheetList, this.sheetParam, this.sheetSearch.value, 'ph-sheet__option');
          }
        });
      }
    }

    openSheet(field, param) {
      if (!this.sheet) return;
      this.openField = field;
      field.classList.add('is-open');
      field.querySelector('.ph-field__trigger').setAttribute('aria-expanded', 'true');
      this.showSheet(param, `${param.name} seçin`, `${this.projectName} · ${param.options.length} seçenek`);
    }

    openProjectSheet() {
      if (!this.sheet) return;
      this.combo.setAttribute('aria-expanded', 'true');
      this.showSheet(this.projectParam(), 'Proje seçin', `${this.projects.length} proje`);
    }

    projectParam() {
      return {
        code: PH_PROJECT_PARAM,
        name: 'Proje',
        options: this.projects.map((p) => ({ key: p.code, label: p.name || p.code })),
      };
    }

    showSheet(param, title, subtitle) {
      this.sheetParam = param;
      this.sheetTitle.textContent = title;
      this.sheetSubtitle.textContent = subtitle;
      const withSearch = param.options.length > PH_SEARCH_THRESHOLD;
      this.sheetSearchWrap.hidden = !withSearch;
      this.sheetSearch.value = '';
      this.renderOptionList(this.sheetList, param, '', 'ph-sheet__option');
      this.sheet.hidden = false;
      document.documentElement.classList.add('ph-sheet-open');
      requestAnimationFrame(() => this.sheet.classList.add('is-visible'));
      const focusTarget = withSearch
        ? this.sheetSearch
        : this.sheetList.querySelector('[aria-selected="true"]') || this.sheetList.querySelector('button');
      if (focusTarget) setTimeout(() => focusTarget.focus(), 50);
    }

    closeSheet(restoreFocus) {
      if (!this.sheet || this.sheet.hidden) return;
      const field = this.openField;
      const wasProject = this.sheetParam && this.sheetParam.code === PH_PROJECT_PARAM;
      this.sheet.classList.remove('is-visible');
      this.sheet.hidden = true;
      document.documentElement.classList.remove('ph-sheet-open');
      if (field) {
        field.classList.remove('is-open');
        const trigger = field.querySelector('.ph-field__trigger');
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      } else if (wasProject && this.combo) {
        this.combo.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.combo.focus();
      }
      this.openField = null;
      this.sheetParam = null;
    }

    /* ---- Ortak seçenek listesi (popover + sheet) ---- */
    renderOptionList(list, param, query, itemClass) {
      const q = (query || '').toLocaleLowerCase('tr').trim();
      const current = param.code === PH_PROJECT_PARAM ? { key: this.projectCode } : this.selections[param.code];
      const options = q
        ? param.options.filter((o) => o.label.toLocaleLowerCase('tr').indexOf(q) !== -1)
        : param.options;
      if (!options.length) {
        list.innerHTML = '<li class="ph-option-empty">Sonuç bulunamadı</li>';
        return;
      }
      list.innerHTML = options
        .map((o) => {
          const selected = current && current.key === o.key;
          return `<li role="presentation"><button type="button" class="${itemClass}" role="option" aria-selected="${
            selected ? 'true' : 'false'
          }" data-key="${this.esc(o.key)}"><span>${this.esc(o.label)}</span>${
            selected
              ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>'
              : ''
          }</button></li>`;
        })
        .join('');
      list.querySelectorAll('button[data-key]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const option = param.options.find((o) => o.key === btn.dataset.key);
          if (option) this.choose(param, option);
        });
      });
    }

    choose(param, option) {
      if (param.code === PH_PROJECT_PARAM) {
        this.closeSheet(true);
        this.onProjectSelected(option.key, option.label);
        return;
      }
      const field = this.querySelector(`.ph-field[data-field="${CSS.escape(param.code)}"]`);
      this.selections[param.code] = option;
      if (field) {
        field.querySelector('.ph-field__input').value = option.key;
        field.querySelector('[data-field-value]').textContent = option.label;
        field.classList.add('is-selected');
      }
      this.hideMessage();
      this.updateProgress();
      if (this.mobileQuery.matches) this.closeSheet(true);
      else {
        this.closeFieldPopover();
        if (field) field.querySelector('.ph-field__trigger').focus();
      }
    }

    updateProgress() {
      if (!this.progressEl) return;
      const total = this.params.length;
      if (!total) {
        this.progressEl.hidden = true;
        return;
      }
      const done = this.params.filter((p) => this.selections[p.code]).length;
      this.progressEl.hidden = false;
      this.progressBar.style.width = `${Math.round((done / total) * 100)}%`;
      this.progressText.textContent = `${done} / ${total} seçildi`;
    }

    bindOutsideClick() {
      document.addEventListener('click', (e) => {
        if (this.combo && !this.combo.contains(e.target)) this.closeCombo();
        if (this.openField && !this.mobileQuery.matches && !this.openField.contains(e.target)) {
          this.closeFieldPopover();
        }
      });
    }

    /* ============ Teklif oluştur + linke _blank ============ */
    onTeklifClick(event) {
      event.preventDefault();
      if (this.loading) return;
      if (!this.projectCode) {
        this.showMessage('Lütfen önce bir proje seçin.');
        return;
      }
      const selections = this.collectSelections();
      if (selections === null) {
        this.showMessage('Lütfen tüm alanları seçin.');
        const firstEmpty = this.querySelector('.ph-field:not(.is-selected) .ph-field__trigger');
        if (firstEmpty) firstEmpty.focus();
        return;
      }
      this.hideMessage();
      this.pendingSelections = selections;
      this.openContact();
    }

    /* ============ İletişim adımı (ad + cep telefonu) ============ */
    wireContact() {
      if (!this.contact || !this.contactForm) return;
      /* Sticky header ve hero'nun stacking context'i modalı örtmesin diye body'ye taşı. */
      document.body.appendChild(this.contact);
      this.contact.querySelectorAll('[data-contact-close]').forEach((el) =>
        el.addEventListener('click', () => {
          if (!this.loading) this.closeContact(true);
        })
      );
      this.contact.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.loading) this.closeContact(true);
      });
      this.contactForm.addEventListener('submit', (e) => this.onContactSubmit(e));
      this.contactPhone.addEventListener('input', () => {
        this.contactPhone.value = this.formatPhone(this.contactPhone.value);
        this.hideContactError();
      });
      this.contactName.addEventListener('input', () => this.hideContactError());
      const saved = this.readSavedContact();
      if (saved) {
        this.contactName.value = typeof saved.name === 'string' ? saved.name : '';
        this.contactPhone.value = this.formatPhone(typeof saved.phone === 'string' ? saved.phone : '');
      }
    }

    openContact() {
      if (!this.contact) return;
      this.lastFocus = document.activeElement;
      if (this.contactSubtitle) {
        this.contactSubtitle.textContent = `${this.projectName} · teklifi kime iletelim?`;
      }
      this.hideContactError();
      this.contact.hidden = false;
      document.documentElement.classList.add('ph-sheet-open');
      requestAnimationFrame(() => this.contact.classList.add('is-visible'));
      const target = this.contactName.value.trim() ? this.contactPhone : this.contactName;
      setTimeout(() => target.focus(), 60);
    }

    closeContact(restoreFocus) {
      if (!this.contact || this.contact.hidden) return;
      this.contact.classList.remove('is-visible');
      this.contact.hidden = true;
      document.documentElement.classList.remove('ph-sheet-open');
      if (restoreFocus && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    onContactSubmit(event) {
      event.preventDefault();
      if (this.loading || !this.pendingSelections) return;
      const name = this.contactName.value.replace(/\s+/g, ' ').trim();
      const phone = this.normalizePhone(this.contactPhone.value);
      if (name.length < 2) {
        this.showContactError('Lütfen adınızı ve soyadınızı girin.');
        this.contactName.focus();
        return;
      }
      if (!phone) {
        this.showContactError('Lütfen geçerli bir cep telefonu numarası girin (5XX XXX XX XX).');
        this.contactPhone.focus();
        return;
      }
      this.saveContact({ name: name, phone: phone });
      /* Popup engelleyiciye takılmamak için sekme tıklama anında (senkron) açılır. */
      const offerTab = window.open('', '_blank');
      this.createOffer(this.pendingSelections, { name: name, phone: phone }, offerTab);
    }

    /** "0532 123 45 67", "+90 532…", "532…" → "5321234567"; cep hattı değilse null. */
    normalizePhone(value) {
      let digits = String(value || '').replace(/\D+/g, '');
      if (digits.indexOf('0090') === 0) digits = digits.slice(4);
      else if (digits.length === 12 && digits.indexOf('90') === 0) digits = digits.slice(2);
      else if (digits.length === 11 && digits.charAt(0) === '0') digits = digits.slice(1);
      return /^5\d{9}$/.test(digits) ? digits : null;
    }

    /** Yazarken "532 123 45 67" biçimi (+90 öneki kutuda ayrı gösterilir). */
    formatPhone(value) {
      let digits = String(value || '').replace(/\D+/g, '');
      if (digits.indexOf('90') === 0 && digits.length > 10) digits = digits.slice(2);
      if (digits.charAt(0) === '0') digits = digits.slice(1);
      digits = digits.slice(0, 10);
      const parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 8), digits.slice(8, 10)];
      return parts.filter(Boolean).join(' ');
    }

    readSavedContact() {
      try {
        const raw = window.localStorage.getItem(PH_CONTACT_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        return parsed && typeof parsed === 'object' ? parsed : null;
      } catch (e) {
        return null;
      }
    }

    saveContact(contact) {
      try {
        window.localStorage.setItem(PH_CONTACT_STORAGE_KEY, JSON.stringify(contact));
      } catch (e) {
        /* depolama kapalıysa sorun değil */
      }
    }

    showContactError(text) {
      if (!this.contactError) return;
      this.contactError.textContent = text;
      this.contactError.hidden = false;
    }

    hideContactError() {
      if (this.contactError) this.contactError.hidden = true;
    }

    collectSelections() {
      if (!this.params.length) return null;
      const selections = {};
      for (const p of this.params) {
        const chosen = this.selections[p.code];
        if (!chosen) return null;
        selections[p.code] = chosen.key;
      }
      return selections;
    }

    async createOffer(selections, contact, offerTab) {
      this.setLoading(true);
      try {
        const res = await fetch(`${this.apiBase}/v1/shopify/appraisal/create-offer`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ project_code: this.projectCode, selections: selections, contact: contact }),
        });
        let data = null;
        try {
          data = await res.json();
        } catch (e) {
          data = null;
        }
        if (res.status === 429) {
          throw new Error('Çok fazla deneme yapıldı. Lütfen birkaç dakika sonra tekrar deneyin.');
        }
        if (!res.ok || !data || data.success !== true || !data.baglanti_url) {
          throw new Error((data && data.message) || 'Teklif oluşturulamadı.');
        }
        this.pendingSelections = null;
        this.closeContact(false);
        if (offerTab && !offerTab.closed) offerTab.location.href = data.baglanti_url;
        else this.showOfferLink(data.baglanti_url);
      } catch (err) {
        if (offerTab && !offerTab.closed) offerTab.close();
        const message = err && err.message ? err.message : 'Teklif oluşturulurken bir hata oluştu.';
        if (this.contact && !this.contact.hidden) this.showContactError(message);
        else this.showMessage(message);
      } finally {
        this.setLoading(false);
      }
    }

    setButtonEnabled(state) {
      if (!this.teklifButton) return;
      this.teklifButton.disabled = !state;
      this.teklifButton.setAttribute('aria-disabled', state ? 'false' : 'true');
    }

    setLoading(state) {
      this.loading = state;
      if (this.contactSubmit) {
        this.contactSubmit.disabled = state;
        this.contactSubmit.classList.toggle('is-loading', state);
        const contactLabel = this.contactSubmit.firstChild;
        if (contactLabel && contactLabel.nodeType === Node.TEXT_NODE) {
          if (state) {
            this.contactSubmit.dataset.label = contactLabel.textContent;
            contactLabel.textContent = 'Teklif hazırlanıyor… ';
          } else if (this.contactSubmit.dataset.label) {
            contactLabel.textContent = this.contactSubmit.dataset.label;
          }
        }
      }
      if (!this.teklifButton) return;
      this.setButtonEnabled(!state && this.hasParams);
      this.teklifButton.classList.toggle('is-loading', state);
      const label = this.teklifButton.firstChild;
      if (!label || label.nodeType !== Node.TEXT_NODE) return;
      if (state) {
        this.teklifButton.dataset.label = label.textContent;
        label.textContent = 'Hesaplanıyor… ';
      } else if (this.teklifButton.dataset.label) {
        label.textContent = this.teklifButton.dataset.label;
      }
    }

    showMessage(text) {
      if (!this.messageEl) return;
      this.messageEl.textContent = text;
      this.messageEl.hidden = false;
    }

    hideMessage() {
      if (this.messageEl) this.messageEl.hidden = true;
    }

    showOfferLink(url) {
      if (!this.messageEl) return;
      this.messageEl.innerHTML = '';
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = 'Teklifinizi görüntülemek için tıklayın';
      this.messageEl.appendChild(a);
      this.messageEl.hidden = false;
    }

    esc(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, (c) => {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
  }

  customElements.define('projects-header', ProjectsHeader);
}
